var _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCleeaiProLogo = function SvgCleeaiProLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 110 33"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M57.071 25.95c-.75 0-1.25-.774-.943-1.459l6.669-14.819c.167-.37.536-.61.943-.61h1.752c.406 0 .775.239.942.61l6.69 14.818a1.034 1.034 0 0 1-.942 1.46h-1c-.412 0-.786-.246-.95-.626l-6.02-14.02a.414.414 0 1 1 .76 0l-5.999 14.019c-.163.38-.536.627-.95.627zm3.347-3.909c-.71 0-1.208-.698-.978-1.369l.135-.393c.143-.418.536-.698.978-.698h7.642c.442 0 .835.28.978.698l.135.393c.23.671-.268 1.37-.978 1.37h-7.912Zm15.685 3.909a1.034 1.034 0 0 1-1.034-1.034v-14.82c0-.57.463-1.033 1.034-1.033h1.068c.571 0 1.034.462 1.034 1.034v14.819c0 .57-.463 1.034-1.034 1.034z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#cleeai-pro-logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cleeai-pro-logo_svg__b)",
    d: "M11.135 25.915q-2.068 0-3.852-.672a9.6 9.6 0 0 1-3.075-1.938 9.1 9.1 0 0 1-2.016-2.973q-.724-1.706-.724-3.722t.724-3.722a8.6 8.6 0 0 1 2.041-2.947A9.1 9.1 0 0 1 7.31 8.003q1.758-.698 3.852-.698 2.223 0 4.058.775a8 8 0 0 1 2.426 1.54c.402.374.362 1.004-.039 1.38l-.698.658c-.418.393-1.071.362-1.519.002a6 6 0 0 0-1.437-.866 6.4 6.4 0 0 0-2.636-.542q-1.422 0-2.61.465a6.2 6.2 0 0 0-2.043 1.318 6.3 6.3 0 0 0-1.344 2.016q-.465 1.164-.465 2.56 0 1.395.465 2.558a6.3 6.3 0 0 0 1.344 2.016 6.2 6.2 0 0 0 2.042 1.318q1.19.465 2.61.466 1.423 0 2.637-.517a6.2 6.2 0 0 0 1.433-.895c.448-.37 1.111-.403 1.532-.002l.692.659c.399.38.434 1.01.029 1.383a8.4 8.4 0 0 1-2.42 1.543q-1.835.775-4.083.775Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cleeai-pro-logo_svg__c)",
    d: "M21.402 25.657a1.034 1.034 0 0 1-1.034-1.034V7.512c0-.571.463-1.034 1.034-1.034h1.163c.571 0 1.034.463 1.034 1.034v17.11c0 .572-.463 1.035-1.034 1.035z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cleeai-pro-logo_svg__d)",
    d: "M33.466 25.838q-2.301 0-4.032-.905-1.706-.93-2.663-2.533-.93-1.602-.93-3.644 0-2.07.905-3.645a6.7 6.7 0 0 1 2.533-2.507q1.628-.905 3.696-.905 2.016 0 3.593.879a6.36 6.36 0 0 1 2.481 2.481q.905 1.604.905 3.774 0 .207-.026.465c0 .28-.238.491-.518.491h-9.976a1.034 1.034 0 0 1-1.034-1.034v-.077c0-.571.463-1.034 1.034-1.034h7.755c.261 0 .349.35.118.472-.17.09-.374-.036-.386-.227a3.75 3.75 0 0 0-1.904-3.088q-.88-.517-2.042-.517-1.189 0-2.094.517a3.76 3.76 0 0 0-1.396 1.447q-.49.905-.49 2.146v.517q0 1.24.568 2.197.569.955 1.603 1.473 1.034.517 2.378.517 1.163 0 2.093-.362.41-.16.78-.4c.515-.333 1.225-.335 1.628.128l.392.451c.337.387.345.97-.044 1.305a6.4 6.4 0 0 1-1.722 1.05q-1.395.568-3.205.568"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cleeai-pro-logo_svg__e)",
    d: "M48.684 25.838q-2.3 0-4.033-.905-1.705-.93-2.662-2.533-.93-1.602-.93-3.644 0-2.07.904-3.645a6.7 6.7 0 0 1 2.533-2.507q1.629-.905 3.696-.905 2.016 0 3.593.879a6.36 6.36 0 0 1 2.482 2.481q.904 1.604.904 3.774 0 .207-.026.465c0 .28-.237.491-.518.491h-9.976a1.034 1.034 0 0 1-1.034-1.034v-.077c0-.571.463-1.034 1.034-1.034h7.756c.261 0 .348.35.117.472-.169.09-.373-.036-.386-.227a3.75 3.75 0 0 0-1.904-3.088q-.878-.517-2.042-.517-1.188 0-2.093.517a3.76 3.76 0 0 0-1.396 1.447q-.49.905-.491 2.146v.517q0 1.24.569 2.197a3.8 3.8 0 0 0 1.602 1.473q1.035.517 2.378.517 1.162 0 2.094-.362a4.3 4.3 0 0 0 .78-.4c.514-.333 1.224-.335 1.627.128l.393.451c.336.387.344.97-.045 1.305a6.4 6.4 0 0 1-1.721 1.05q-1.396.568-3.206.568Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.6,
    d: "M83.68 26V14.8h4.368q1.472 0 2.512.464t1.6 1.344.56 2.096-.56 2.096q-.56.864-1.6 1.344-1.04.464-2.512.464H84.56l.72-.752V26zm1.6-3.984-.72-.8H88q1.536 0 2.32-.656.8-.656.8-1.856c0-1.2-.267-1.419-.8-1.856q-.784-.656-2.32-.656h-3.44l.72-.8zM94.85 26v-8.48h1.472v2.304l-.144-.576a2.6 2.6 0 0 1 1.184-1.344q.833-.464 2.048-.464v1.488a1 1 0 0 0-.192-.016h-.16q-1.232 0-1.952.736-.72.735-.72 2.128V26zm10.167.096q-1.28 0-2.272-.56A4.17 4.17 0 0 1 101.177 24q-.576-.992-.576-2.24 0-1.265.576-2.24a4.05 4.05 0 0 1 1.568-1.52q.993-.56 2.272-.56 1.264 0 2.256.56a3.9 3.9 0 0 1 1.568 1.52q.576.96.576 2.24 0 1.265-.576 2.24a4 4 0 0 1-1.568 1.536q-.992.56-2.256.56m0-1.344a2.87 2.87 0 0 0 1.456-.368 2.6 2.6 0 0 0 1.024-1.04q.368-.688.368-1.584 0-.912-.368-1.568a2.6 2.6 0 0 0-1.024-1.04 2.87 2.87 0 0 0-1.456-.368 2.87 2.87 0 0 0-1.456.368 2.75 2.75 0 0 0-1.024 1.04q-.384.656-.384 1.568 0 .896.384 1.584.385.672 1.024 1.04a2.87 2.87 0 0 0 1.456.368"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "cleeai-pro-logo_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(151.297 23.493 12.261)scale(54.0353 101.398)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E92CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cleeai-pro-logo_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(151.297 23.493 12.261)scale(54.0353 101.398)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E92CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cleeai-pro-logo_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(151.297 23.493 12.261)scale(54.0353 101.398)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E92CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cleeai-pro-logo_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(151.297 23.493 12.261)scale(54.0353 101.398)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E92CC"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cleeai-pro-logo_svg__a",
    width: 53.704,
    height: 19.437,
    x: 1.468,
    y: 6.478,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.723
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_3161_2580"
  })))));
};
export default SvgCleeaiProLogo;